import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { installNativeApiProxy } from "./lib/native-origin";
import { installBundleVersionWatcher } from "./lib/bundle-version";
import { installDiagnosticsFetchInstrumentation } from "./lib/diagnostics/instrument";

export const getRouter = () => {
  // Earliest client-side code path: when the app is running from the assets
  // bundled inside the APK, relative /_serverFn and /api calls must be pointed
  // at the deployed origin before any route or component can issue one.
  installNativeApiProxy();
  // Wrap fetch AFTER the native proxy so diagnostics observe the final URL.
  // This is what guarantees no API call anywhere in the app — Supabase REST,
  // RPC, Auth, Storage, server functions, server routes — escapes diagnostics.
  installDiagnosticsFetchInstrumentation();
  // After an APK update the WebView may still hold the previous index.html;
  // this detects the stale document and reloads onto the new bundle.
  installBundleVersionWatcher();


  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Cache reads for 30s so tab switches and back-nav don't refetch.
        staleTime: 30_000,
        // Keep unused caches for 5 min so navigating back is instant.
        gcTime: 5 * 60_000,
        // Mobile browsers fire focus events aggressively — don't thrash.
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
      mutations: { retry: 0 },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
